"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themes = void 0;
const tslib_1 = require("tslib");
const ace_dark_1 = require("./ace/ace-dark");
const ace_light_1 = require("./ace/ace-light");
const esg_dark_1 = require("./esg/esg-dark");
const esg_light_1 = require("./esg/esg-light");
const next_gen_dark_1 = require("./next-gen/next-gen-dark");
const next_gen_light_1 = require("./next-gen/next-gen-light");
const project_citrus_light_1 = require("./project-citrus/project-citrus-light");
const team_dark_1 = require("./team/team-dark");
const team_light_1 = require("./team/team-light");
const website_dark_1 = require("./website/website-dark");
const website_light_1 = require("./website/website-light");
exports.themes = {
    ACELight: ace_light_1.theme,
    ACEDark: ace_dark_1.theme,
    ESGLight: esg_light_1.theme,
    ESGDark: esg_dark_1.theme,
    NextGenLight: next_gen_light_1.theme,
    NextGenDark: next_gen_dark_1.theme,
    WebsiteLight: website_light_1.theme,
    WebsiteDark: website_dark_1.theme,
    TeamLight: team_light_1.theme,
    TeamDark: team_dark_1.theme,
    ProjectCitrusLight: project_citrus_light_1.theme,
};
tslib_1.__exportStar(require("./fonts"), exports);
//# sourceMappingURL=index.js.map